module.exports = __webpack_public_path__ + "static/media/aedo.7416b386.jpg";